var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10.524,
    height: 13.571,
    viewBox: "0 0 10.524 13.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3614",
    "data-name": "Path 3614",
    d: "M8.869-8.548a3.44,3.44,0,0,0,3.44-3.44,3.44,3.44,0,0,0-3.44-3.44,3.44,3.44,0,0,0-3.441,3.44A3.445,3.445,0,0,0,8.869-8.548Zm0-5.543a2.109,2.109,0,0,1,2.109,2.11,2.109,2.109,0,0,1-2.109,2.11,2.11,2.11,0,0,1-2.11-2.11A2.11,2.11,0,0,1,8.869-14.091Z",
    transform: "translate(-5.429 15.429)",
    fill: "#06233d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3613",
    "data-name": "Path 3613",
    d: "M-513,3354.666H2207V-4556H-513Z",
    transform: "translate(513 4556)",
    fill: "#06233d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3617",
    "data-name": "Path 3617",
    d: "M9.548-9.428A5.159,5.159,0,0,0,5.823-7.881,5.443,5.443,0,0,0,4.286-4.016a.662.662,0,0,0,.663.658h9.2a.662.662,0,0,0,.663-.658,5.443,5.443,0,0,0-1.538-3.865A5.158,5.158,0,0,0,9.548-9.428ZM5.658-4.674A4.017,4.017,0,0,1,6.771-6.959,3.917,3.917,0,0,1,9.548-8.111a3.917,3.917,0,0,1,2.777,1.152,4.038,4.038,0,0,1,1.113,2.285Z",
    transform: "translate(-4.286 9.429)",
    fill: "#06233d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14941",
    "data-name": "Group 14941",
    transform: "translate(-4.286 15.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2341",
    "data-name": "Group 2341",
    transform: "translate(5.905 -15.429)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2340",
    "data-name": "Group 2340",
    transform: "translate(-734.44 -6432.476)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3612",
    "data-name": "Path 3612",
    d: "M.429-20.429H21.476V.619H.429Z",
    transform: "translate(726.929 6445.821)",
    fill: "#06233d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2343",
    "data-name": "Group 2343",
    transform: "translate(4.286 -7.929)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2342",
    "data-name": "Group 2342",
    transform: "translate(-732.821 -6440.976)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3615",
    "data-name": "Path 3615",
    d: "M-.714-14.429h24.69V5.81H-.714Z",
    transform: "translate(726.452 6448.321)",
    fill: "#06233d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.29fa569e078eb7452f8e386a6a4af64f.svg";
export { ForwardRef as ReactComponent };